import { useNavigate } from 'react-router-dom';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import PrimaryButton from '../../components/Button/PrimaryButton';
import Page from '../../components/Page/Page';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';

export default function SignUpCompletePage() {
  const navigate = useNavigate();

  return (
    <Page title="Darum | Sign up">
      <AuthLayout
        headerImgSrc="/static/svg/signup-complete-success.svg"
        formHeaderTitle="All Set"
        formHeaderDescription="Your password has been set successfully"
      >
        <PrimaryButton onClick={() => navigate(`/${ACCOUNT}/${SIGNIN}`)}>
          Sign in
        </PrimaryButton>
      </AuthLayout>
    </Page>
  );
}
